import { useMemo } from 'react';

const DEFAULT_PRODUCT_FILTER_STATE = {
  isFiltered: false,
  currentProductId: null,
  productName: '',
};

/**
 * Custom hook for managing product filter state
 * @param {Object} selectedProduct - Currently selected product
 * @returns {Object} Product filter state
 */
const useProductFilterState = selectedProduct => {
  const isProductIdFiltered = useMemo(
    () =>
      selectedProduct
        ? {
            isFiltered: true,
            currentProductId: selectedProduct.id,
            productName: selectedProduct.name,
          }
        : DEFAULT_PRODUCT_FILTER_STATE,
    [selectedProduct]
  );

  return { isProductIdFiltered };
};

export default useProductFilterState;
